var EASING_FUNCTION = "cubic-bezier(0.16, 1, 0.3, 1)";
export default EASING_FUNCTION;